import { ApolloClient } from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { BatchHttpLink } from 'apollo-link-batch-http';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ENDPOINTS } from '@/settings/endpoints';
import gql from 'graphql-tag';
import fetch from 'unfetch';

export enum ServicesEnum {
  BOARDS_GROUPS = 'boardsGroups',
  POSTGRAD_STUDY_PLANNING = 'postgradStudyPlanning',
}

const URLs = {
  boardsGroups: ENDPOINTS.postgradBoardsGroupsUrl,
  postgradStudyPlanning: ENDPOINTS.postgradStudyPlanningUrl,
};

export const apolloClients = {};

const getApolloClient = (microservice: ServicesEnum) => {
  if (!apolloClients[microservice]) {
    const httpLink = new BatchHttpLink({
      uri: URLs[microservice],
      fetchOptions: fetch,
    });

    const authLink = setContext((_, { headers }) => {
      const token = localStorage.getItem('token');

      if (token) {
        return {
          headers: {
            ...headers,
            authorization: `Bearer ${token}`,
          },
        };
      }

      return headers;
    });

    const link = ApolloLink.from([authLink, httpLink]);

    apolloClients[microservice] = new ApolloClient({
      link,
      cache: new InMemoryCache(),
      connectToDevTools: true,
      defaultOptions: {
        query: {
          fetchPolicy: 'no-cache',
        },
      },
    });
  }

  return apolloClients[microservice];
};

export async function graphqlQuery(
  service: ServicesEnum,
  query: string,
  variables?: { [key: string]: any },
): Promise<any> {
  return await getApolloClient(service).query<any>({
    query: gql(query),
    variables,
  });
}

export async function graphqlMutation(
  microservice: ServicesEnum,
  mutation: string,
  variables?: { [key: string]: any },
): Promise<any> {
  return await getApolloClient(microservice).mutate<any>({
    mutation: gql(mutation),
    variables,
  });
}
